import { Button } from "@repo/ui/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/ui/components/ui/dropdown-menu"
import { Row } from "@tanstack/react-table"
import { MoreHorizontal } from "lucide-react"
import { useTranslations } from "use-intl"

interface DataTableRowActionsProps<TData> {
  row: Row<TData>
  remove?: (row: TData) => void
  edit?: () => void
  duplicate?: (row: TData) => void
}

function DataTableRowActions<TData>({
  row,
  remove,
  edit,
  duplicate,
}: DataTableRowActionsProps<TData>) {
  const t = useTranslations("ui.dataTable.rowActions")
  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
          >
            <MoreHorizontal />
            <span className="sr-only">{t("openMenu")}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          {edit && (
            <DropdownMenuItem onSelect={() => edit()}>
              {t("edit")}
            </DropdownMenuItem>
          )}
          {duplicate && (
            <DropdownMenuItem onSelect={() => duplicate(row.original)}>
              {t("duplicate")}
            </DropdownMenuItem>
          )}
          {remove && (
            <DropdownMenuItem
              className="text-destructive focus:text-destructive focus:bg-destructive/10"
              onSelect={() => remove(row.original)}
            >
              {t("delete")}
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export default DataTableRowActions
